const filterConfig = {
  type: 'object',
  properties: {
        // customer_id: { 
        //     type: 'integer', 
        // },
        // report_id: { 
        //     type: 'integer', 
        // },
        search: {
            type: 'string',
        },
        room_id: {
          type: 'integer',
        },        
        event_type_id: {
          type: 'integer',
        }
    }
}
const getFiltersConfig: any = (type: string) => {
  return filterConfig;
}
export default getFiltersConfig;